import { NgComponentOutlet } from '@angular/common';
import { Component, Input, OnInit, Type, inject } from '@angular/core';
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { CustomViewService, ICustomViewComponent } from "@tylertech/custom-view";
import { IMapFeature, PropertyMetadata } from "@tylertech/tyler-api-types";
import { AugmentedModelObject, RepositoryFormData } from "../../interfaces";
import { MetadataEventService, MetadataPropertyService } from "../../services";

export interface SpatialMapBindingObject extends Record<string, unknown>
{
    readonly propertyMetadata: PropertyMetadata;
    readonly metadataModel: AugmentedModelObject;
    readonly formRepository: RepositoryFormData;
    readonly parent: AugmentedModelObject;
    readonly model: IMapFeature[];
    updateMap: boolean;
    readonly callRecalculate: any;
}

@Component({
    selector: "metadata-spatial-map",
    templateUrl: "./metadataSpatialMap.tmpl.html",
    imports: [NgComponentOutlet]
})
export class MetadataSpatialMapComponent implements OnInit
{
    private readonly $metadataPropertyService = inject(MetadataPropertyService);
    private readonly $metadataEventService = inject(MetadataEventService);
    private readonly $customViewService = inject(CustomViewService);

    @Input() propertyMetadata: PropertyMetadata;
    @Input() metadataModel: AugmentedModelObject;
    @Input() formRepository: RepositoryFormData;
    @Input() parent: AugmentedModelObject;
    @Input() model: IMapFeature[];

    customDataBinding: SpatialMapBindingObject;

    mapComponent: Type<ICustomViewComponent<unknown>>;

    constructor()
    {
        this.$metadataEventService.onRecalculateWorking.pipe(takeUntilDestroyed())
            .subscribe(args =>
            {
                if (!args.Recalculating)
                {
                    this.customDataBinding.updateMap = true;
                    requestAnimationFrame(() =>
                    {
                        this.customDataBinding.updateMap = false;
                    });
                }
            });
    }

    ngOnInit()
    {
        this.customDataBinding = {
            propertyMetadata: this.propertyMetadata,
            metadataModel: this.metadataModel,
            formRepository: this.formRepository,
            parent: this.parent,
            model: this.model,
            updateMap: false,
            callRecalculate: this.callRecalculateBind()
        };
        this.mapComponent = this.$customViewService.getView("spatial-map").component;
    }

    private _callRecalculateBind: any;

    callRecalculateBind(): unknown
    {
        if (!this._callRecalculateBind)
        {
            this._callRecalculateBind = (arg: any) => this.callRecalculate(arg);
        }
        return this._callRecalculateBind;
    }


    callRecalculate($event: any): void
    {
        const self = this;
        const originalData = self.metadataModel[self.propertyMetadata.Name];
        let featureAsArray: IMapFeature[];
        if ($event.feature != null)
        {
            featureAsArray = [$event.feature];
        }
        else
        {
            featureAsArray = $event.features;
        }

        let type = self.metadataModel.$$TypeName;
        if (!type && self.formRepository) type = self.formRepository.Type;
        self.$metadataPropertyService.recalculateProperties(
            type,
            self.propertyMetadata,
            self.metadataModel,
            self.parent,
            featureAsArray,
            undefined,
            true,
            true,
            self.formRepository
        ).then(_x => self.metadataModel[self.propertyMetadata.Name] = originalData);
    }
}
